<template>
  <div class="component-ocr-idcard">
  <!-- <div :class="empty" class="component-ocr-idcard-step">STEP 1：通过照片OCR方式获取身份证信息</div> -->
  <!-- <div class="component-ocr-idcard-btn-wrap">
      <van-button :loading="loading" :disabled="remainTime < 30" plain block round hairline type="primary" color="#0761F3" @click="handleOcrScan">
        <i v-if="remainTime === 30" class="page-rnr-userinfo-ocr" />{{ remainTime === 30 ? 'OCR' : `${remainTime}s后重试` }}
      </van-button>
    </div> -->
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { Toast } from 'vant'
import { ocrIdcard } from '@/api/markup'
import { ocrIdcardInEnterprise } from '@/api/rnr'

export default {
  name: 'IdcardOcr',
  props: {
    images: {
      type: Array,
      default: () => ([])
    },
    customer: {
      type: Boolean,
      default: false
    },
    empty: {
      type: String,
      default: 'normal'
    }
  },
  data() {
    return {
      remainTime: 30,
      loading: false,
      formData: {}
    }
  },
  methods: {
    /**
     * 读取文件后，开始上传文件
     * @param file 当前选中的文件
     */
    async handleAfterRead(dataURL = '') {
      try {
        // 如果先压缩图片
        const ocrPic = dataURL.replace('data:image/jpeg;base64,', '')
        // 文件可访问路径和文件的uuid
        const respData = await (this.customer ? ocrIdcard : ocrIdcardInEnterprise)({ ocrPic })
        // 标记当前是身份证
        this.formData = {
          ...this.formData,
          ...(this.value || {}),
          certType: 'IDCARD'
        }
        // 身份证信息
        if (respData.side === 'back') {
          this.formData.fullName = respData.fullName
          this.formData.gender = respData.gender === '男' ? 1 : 2
          this.formData.certNumber = respData.certNumber
          this.formData.certAddress = respData.address
        } else {
          // 过期时间格式化
          const validDate = respData.validDate.split('-')
          // 如果当前是长期
          if (validDate.length === 2) {
            this.formData.certExpirationDate = validDate[1].replace(/\./g, '-')
            // 当前过期时间
            const expireDateInDayjs = dayjs(this.formData.certExpirationDate, 'YYYY-MM-DD')
            // 如果身份证读取的过期时间小于当前天数
            if (expireDateInDayjs.isBefore(dayjs().startOf('date'))) {
              Toast('当前身份证已过期，请注意更换')
              this.formData.certExpirationDate = ''
            }
          } else {
            this.formData.certExpirationDate = respData.validDate
          }
        }
      } catch (error) {
        console.error(error)
      }
    },

    /**
     * ocr扫描识别
     */
    async handleOcrScan() {
      // 增加loading框
      this.loading = true
      // 开始全部上传接口
      await Promise.all(this.images.map(this.handleAfterRead))
      // 触发改变方法
      this.$emit('change', { ...this.formData })
      // 开启禁用ocr倒计时
      this.disableOcrScanTimer()
      // 接触loading状态
      this.loading = false
    },

    /**
     * 开始禁用ocr识别功能
     */
    disableOcrScanTimer() {
      // 如果当前有进行中的定时器
      this.timer && clearTimeout(this.timer)
      // 如果当前倒计时结束
      if (this.remainTime === 0) {
        this.remainTime = 30
        return
      }
      // 开始减去数字
      this.remainTime -= 1
      // 开始倒计时
      this.timer = setTimeout(this.disableOcrScanTimer.bind(this), 1000)
    }
  }
}
</script>

<style lang="scss">
.component-ocr-idcard {
  background-color: #ffffff;
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 0 32px 0;
  .component-ocr-idcard-step {
    color: rgba(36, 36, 36, 0.4);
    font-size: 24px;
    font-weight: 400;
    line-height: 30px;
    height: 128px;
    margin-top: 12px;
    &.small {
      height: 60px;
    }
  }
  .component-ocr-idcard-btn-wrap {
    margin-top: 24px;
    .van-button {
      font-size: 30px;
      height: 88px;
      .page-rnr-userinfo-ocr {
        background-image: url(../../assets/rnr/icon_ocr.svg);
        background-size: 100% 100%;
        display: inline-block;
        width: 30px;
        height: 30px;
        margin: 0 12px -2px 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Ocr/Idcard.vue